import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory, extractRelativeActionUrl } from './types';

const recommendationMovePills = (): string[] => ['Recommendation'];

const recommendationMoveDefaults = {
  audience: PERMISSIONS.VIEW_RECOMMENDATIONS,
  scope: 'entity' as const,
  defaultChannels: ['in_app' as const],
};

export const recommendationAssignedDescriptor = defineNotificationCategory(
  'recommendation_assigned',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationCompletedDescriptor = defineNotificationCategory(
  'recommendation_completed',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationDismissedDescriptor = defineNotificationCategory(
  'recommendation_dismissed',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationReopenedDescriptor = defineNotificationCategory(
  'recommendation_reopened',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationRestoredDescriptor = defineNotificationCategory(
  'recommendation_restored',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationUnassignedDescriptor = defineNotificationCategory(
  'recommendation_unassigned',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationReviewDescriptor = defineNotificationCategory('recommendation_review', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: recommendationMovePills,
  ...recommendationMoveDefaults,
});

export const recommendationAutoclosedDescriptor = defineNotificationCategory(
  'recommendation_autoclosed',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: recommendationMovePills,
    ...recommendationMoveDefaults,
  },
);

export const recommendationStaleDescriptor = defineNotificationCategory('recommendation_stale', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: recommendationMovePills,
  ...recommendationMoveDefaults,
});

export const recommendationKeptDescriptor = defineNotificationCategory('recommendation_kept', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: recommendationMovePills,
  ...recommendationMoveDefaults,
});
